@import "igws-accordion.less";

.accordion__label {
  padding: 30px 30px 0 0;
}

.accordion--expanded {
  .accordion__content {
    padding-right: 30px;
  }
}

.accordion--plus {
  &::after {
    right: 0;
  }  
}